import React, { useState } from "react"
import { Link } from "gatsby"
import Navbar from "./Navbar"
import { Collapse, Menu } from "./Icons"
import logo from "../assets/images/logo.svg"

const Header = ({ lang = "en" }) => {
  const [navClass, setNavClass] = useState("nav collapsible")
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleMenuToggle = () => {
    if (navClass.includes("collapsible--expanded")) {
      setNavClass("nav collapsible")
      setIsMenuOpen(false)
    } else {
      setNavClass("nav collapsible collapsible--expanded")
      setIsMenuOpen(true)
    }
  }

  return (
    <nav className={navClass}>
      <div className="nav__top_section">
        <Link to={lang === "cn" ? "/cn/" : "/"}>
          <div className="nav__logo">
            <img src={logo} alt="CanHK logo" />
          </div>
        </Link>

        {isMenuOpen ? (
          <Collapse
            className="nav__icon nav__toggler"
            onClick={handleMenuToggle}
          />
        ) : (
          <Menu className="nav__icon nav__toggler" onClick={handleMenuToggle} />
        )}
      </div>

      <Navbar lang={lang} handleMenuToggle={handleMenuToggle} />
    </nav>
  )
}

export default Header
